/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Admin_Discount_Code_Form_Discount_OffInputs */

const en_admin_discount_code_form_discount_off = /** @type {(inputs: Admin_Discount_Code_Form_Discount_OffInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.amount} off`)
};

const de_admin_discount_code_form_discount_off = /** @type {(inputs: Admin_Discount_Code_Form_Discount_OffInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.amount} Rabatt`)
};

const es_admin_discount_code_form_discount_off = /** @type {(inputs: Admin_Discount_Code_Form_Discount_OffInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.amount} de descuento`)
};

const fr_admin_discount_code_form_discount_off = /** @type {(inputs: Admin_Discount_Code_Form_Discount_OffInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.amount} de réduction`)
};

/** @type {(inputs: Admin_Discount_Code_Form_Discount_OffInputs) => LocalizedString} */
const it_admin_discount_code_form_discount_off = en_admin_discount_code_form_discount_off;

/** @type {(inputs: Admin_Discount_Code_Form_Discount_OffInputs) => LocalizedString} */
const pt_br2_admin_discount_code_form_discount_off = en_admin_discount_code_form_discount_off;

/** @type {(inputs: Admin_Discount_Code_Form_Discount_OffInputs) => LocalizedString} */
const pl_admin_discount_code_form_discount_off = en_admin_discount_code_form_discount_off;

/** @type {(inputs: Admin_Discount_Code_Form_Discount_OffInputs) => LocalizedString} */
const hu_admin_discount_code_form_discount_off = en_admin_discount_code_form_discount_off;

/** @type {(inputs: Admin_Discount_Code_Form_Discount_OffInputs) => LocalizedString} */
const ro_admin_discount_code_form_discount_off = en_admin_discount_code_form_discount_off;

/**
* | output |
* | --- |
* | "{amount} off" |
*
* @param {Admin_Discount_Code_Form_Discount_OffInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_discount_code_form_discount_off = /** @type {((inputs: Admin_Discount_Code_Form_Discount_OffInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Discount_Code_Form_Discount_OffInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_discount_code_form_discount_off(inputs)
	if (locale === "de") return de_admin_discount_code_form_discount_off(inputs)
	if (locale === "es") return es_admin_discount_code_form_discount_off(inputs)
	if (locale === "fr") return fr_admin_discount_code_form_discount_off(inputs)
	if (locale === "it") return it_admin_discount_code_form_discount_off(inputs)
	if (locale === "pt-BR") return pt_br2_admin_discount_code_form_discount_off(inputs)
	if (locale === "pl") return pl_admin_discount_code_form_discount_off(inputs)
	if (locale === "hu") return hu_admin_discount_code_form_discount_off(inputs)
	return ro_admin_discount_code_form_discount_off(inputs)
});
export { admin_discount_code_form_discount_off as "admin.discount_code_form.discount_off" }